import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { DispatcherService } from '@frontend/sports/common/core/utils/dispatcher';
import { StringDictionary } from '@frontend/sports/common/core/utils/extended-types';
import { TrackingService } from '@frontend/sports/tracking/feature';
import { HtmlNode } from '@frontend/vanilla/core';

import { CrmPromotionProviderService, PromotionMap } from '../../../crm-promotion/crm-promotion-provider.service';
import { AdaptiveLayoutService } from '../../../layout/adaptive-layout.service';
import { RedirectHelperService } from '../../../navigation-core/redirect-helper.service';
import { UrlHelperService } from '../../../navigation-core/url-helper.service';
import { TournamentBaseComponent } from './tournament-base.component';

@Component({
    selector: 'ms-horses-tournament-selector',
    templateUrl: 'horses-tournament-selector.component.html',
    standalone: false,
})
export class HorsesTournamentSelectorComponent extends TournamentBaseComponent implements OnInit, OnDestroy {
    @Input() isSports: boolean;

    promotedMeetingIdsMap: StringDictionary<number> = {};

    constructor(
        protected override dipatcher: DispatcherService,
        protected override redirectHelper: RedirectHelperService,
        private layoutService: AdaptiveLayoutService,
        protected override htmlNode: HtmlNode,
        protected override trackingService: TrackingService,
        protected override sitecore: Sitecore,
        private crmPromotionProvider: CrmPromotionProviderService,
        protected override urlHelper: UrlHelperService,
    ) {
        super(dipatcher, redirectHelper, trackingService, sitecore, htmlNode, urlHelper);
    }

    ngOnInit(): void {
        this.crmPromotionProvider.promotionsMap$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((ids) => this.promotionMapChanged(ids));
        this.dipatcherHorseRacing();
    }

    get isVisible(): boolean {
        return this.isSports ? !!this.layoutService.current.breadcrumbNavigation && this.isOpen : this.isOpen;
    }

    private promotionMapChanged(promoMap: PromotionMap): void {
        this.promotedMeetingIdsMap = promoMap.meetings;
    }
}
